import angular from 'angular'
import userTable from './user_table'
import exportUsersCsv from './export_users_csv'
import licenseCriteriaPicker from './license_criteria_picker'
import userCache from './usercache'
import cacheMetadataView from './cache_metadata_view'
import refreshUserCacheButtons from './refresh_user_cache_buttons'

export default angular
  .module('adminPanel.userFilter', [])
  .factory('userCache', userCache)
  .component('cacheMetadataView', cacheMetadataView)
  .component('refreshUserCacheButtons', refreshUserCacheButtons)
  .constant('UserCSVHeaders', {
    uuid: 'Uuid',
    name: 'Name',
    email: 'Email',
    title: 'Title',
    password: 'Password',
    school: 'School',
    product: 'Product',
    type: 'Type',
    sub_type: 'Sub Type',
    start_date: 'Start Date',
    end_date: 'End Date',
    license_uuid: 'License Uuid',
    tags: 'Tags',
    sub_groups: 'Subgroups',
    supergroups: 'Supergroups',
    sso_external_id: 'SSO External ID'
  })
  .directive('userTable', userTable)
  .directive('exportUsersCsv', exportUsersCsv)
  .directive('licenseCriteriaPicker', licenseCriteriaPicker)
